import { render, staticRenderFns } from "./KF.vue?vue&type=template&id=863efe64&"
import script from "./KF.vue?vue&type=script&lang=js&"
export * from "./KF.vue?vue&type=script&lang=js&"
import style0 from "./KF.vue?vue&type=style&index=0&id=863efe64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports